import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

export default {
  /**
     * 初始化APP环境的分享功能
     */
  initAPPShare: async (shareConfig) => {
    console.log('run initAPPShare params is   ', shareConfig);
    window.TGMobileShare = window?.TGMobileShare || (() => { });
    window.TGMobileShare({
      shareTitle: shareConfig?.title || '',
      shareDesc: shareConfig?.desc || '',
      shareImgUrl: shareConfig?.icon || 'https://ossweb-img.qq.com/images/tgclub/act/a20190221photo/Supercore-Icon-1.jpg',
      shareLink: shareConfig?.link || window.location.href,
      actName: `ceiba_${Vue.prototype.$actInfo.activity_id}`,
    });
  },
  isAPP: () => {
    return common.tool.getCookie('logintype') === 'supercore_m';
  },
  getPlatform: () => {
    return common.tool.getCookie('logintype') === 'supercore_m' ? 'app' : '';
  },
  openView: (options) => {
    window.location.href = options.url;
  },
};
